// Boolean sort method.
export const booleanSortType = (rowA, rowB, columnId, desc) => {
  const a = rowA.values[columnId];
  const b = rowB.values[columnId];
  if (a === b) {
    return 0;
  }
  return a && !b ? -1 : 1;
};
